import { render, staticRenderFns } from "./businessmain.vue?vue&type=template&id=3dba5e22&scoped=true"
import script from "./businessmain.vue?vue&type=script&lang=js"
export * from "./businessmain.vue?vue&type=script&lang=js"
import style0 from "./businessmain.vue?vue&type=style&index=0&id=3dba5e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba5e22",
  null
  
)

export default component.exports